import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateTaskAssignmentMutationVariables = Types.Exact<{
  input: Types.CreateTaskAssignmentInput;
}>;


export type CreateTaskAssignmentMutation = { __typename?: 'Mutation', createTaskAssignment: { __typename?: 'TaskAssignmentPayload', taskAssignment?: { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, notes: Array<{ __typename?: 'TaskAssignmentNoteData', content: string, addedBy: string, addedAt: Types.TDateISO }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type StartTaskMutationVariables = Types.Exact<{
  input: Types.StartTaskInput;
}>;


export type StartTaskMutation = { __typename?: 'Mutation', startTask: { __typename?: 'TaskAssignmentPayload', taskAssignment?: { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, notes: Array<{ __typename?: 'TaskAssignmentNoteData', content: string, addedBy: string, addedAt: Types.TDateISO }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CompleteTaskMutationVariables = Types.Exact<{
  input: Types.CompleteTaskInput;
}>;


export type CompleteTaskMutation = { __typename?: 'Mutation', completeTask: { __typename?: 'TaskAssignmentPayload', taskAssignment?: { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, notes: Array<{ __typename?: 'TaskAssignmentNoteData', content: string, addedBy: string, addedAt: Types.TDateISO }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CancelTaskMutationVariables = Types.Exact<{
  input: Types.CancelTaskInput;
}>;


export type CancelTaskMutation = { __typename?: 'Mutation', cancelTask: { __typename?: 'TaskAssignmentPayload', taskAssignment?: { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, notes: Array<{ __typename?: 'TaskAssignmentNoteData', content: string, addedBy: string, addedAt: Types.TDateISO }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReassignTaskMutationVariables = Types.Exact<{
  input: Types.ReassignTaskInput;
}>;


export type ReassignTaskMutation = { __typename?: 'Mutation', reassignTask: { __typename?: 'TaskAssignmentPayload', taskAssignment?: { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, notes: Array<{ __typename?: 'TaskAssignmentNoteData', content: string, addedBy: string, addedAt: Types.TDateISO }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ChangeTaskAssignmentDueDateMutationVariables = Types.Exact<{
  input: Types.AssignDueDateInput;
}>;


export type ChangeTaskAssignmentDueDateMutation = { __typename?: 'Mutation', changeTaskAssignmentDueDate: { __typename?: 'TaskAssignmentPayload', taskAssignment?: { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, notes: Array<{ __typename?: 'TaskAssignmentNoteData', content: string, addedBy: string, addedAt: Types.TDateISO }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddTaskAssignmentNoteMutationVariables = Types.Exact<{
  input: Types.AddNoteInput;
}>;


export type AddTaskAssignmentNoteMutation = { __typename?: 'Mutation', addTaskAssignmentNote: { __typename?: 'TaskAssignmentPayload', taskAssignment?: { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, notes: Array<{ __typename?: 'TaskAssignmentNoteData', content: string, addedBy: string, addedAt: Types.TDateISO }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type StartTaskAssignmentTimerMutationVariables = Types.Exact<{
  input: Types.StartTimerInput;
}>;


export type StartTaskAssignmentTimerMutation = { __typename?: 'Mutation', startTaskAssignmentTimer: { __typename?: 'TaskAssignmentPayload', taskAssignment?: { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, notes: Array<{ __typename?: 'TaskAssignmentNoteData', content: string, addedBy: string, addedAt: Types.TDateISO }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type StopTaskAssignmentTimerMutationVariables = Types.Exact<{
  input: Types.StopTimerInput;
}>;


export type StopTaskAssignmentTimerMutation = { __typename?: 'Mutation', stopTaskAssignmentTimer: { __typename?: 'TaskAssignmentPayload', taskAssignment?: { __typename?: 'TaskAssignmentStateData', taskAssignmentId: string, taskEventName: string, assignedTo?: string | null, status: Types.TaskAssignmentStatus, sourceLevel: Types.TaskAssignmentSourceLevel, productionJobId?: string | null, productionJobNumber?: number | null, startedAt?: Types.TDateISO | null, startedBy?: string | null, completedAt?: Types.TDateISO | null, completedBy?: string | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string, notes: Array<{ __typename?: 'TaskAssignmentNoteData', content: string, addedBy: string, addedAt: Types.TDateISO }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateTaskAssignmentDocument = new TypedDocumentString(`
    mutation CreateTaskAssignment($input: CreateTaskAssignmentInput!) {
  createTaskAssignment(input: $input) {
    taskAssignment {
      ...TaskAssignmentDetail
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskAssignmentDetail on TaskAssignmentStateData {
  taskAssignmentId
  taskEventName
  assignedTo
  status
  sourceLevel
  productionJobId
  productionJobNumber
  startedAt
  startedBy
  completedAt
  completedBy
  notes {
    content
    addedBy
    addedAt
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const StartTaskDocument = new TypedDocumentString(`
    mutation StartTask($input: StartTaskInput!) {
  startTask(input: $input) {
    taskAssignment {
      ...TaskAssignmentDetail
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskAssignmentDetail on TaskAssignmentStateData {
  taskAssignmentId
  taskEventName
  assignedTo
  status
  sourceLevel
  productionJobId
  productionJobNumber
  startedAt
  startedBy
  completedAt
  completedBy
  notes {
    content
    addedBy
    addedAt
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const CompleteTaskDocument = new TypedDocumentString(`
    mutation CompleteTask($input: CompleteTaskInput!) {
  completeTask(input: $input) {
    taskAssignment {
      ...TaskAssignmentDetail
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskAssignmentDetail on TaskAssignmentStateData {
  taskAssignmentId
  taskEventName
  assignedTo
  status
  sourceLevel
  productionJobId
  productionJobNumber
  startedAt
  startedBy
  completedAt
  completedBy
  notes {
    content
    addedBy
    addedAt
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const CancelTaskDocument = new TypedDocumentString(`
    mutation CancelTask($input: CancelTaskInput!) {
  cancelTask(input: $input) {
    taskAssignment {
      ...TaskAssignmentDetail
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskAssignmentDetail on TaskAssignmentStateData {
  taskAssignmentId
  taskEventName
  assignedTo
  status
  sourceLevel
  productionJobId
  productionJobNumber
  startedAt
  startedBy
  completedAt
  completedBy
  notes {
    content
    addedBy
    addedAt
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const ReassignTaskDocument = new TypedDocumentString(`
    mutation ReassignTask($input: ReassignTaskInput!) {
  reassignTask(input: $input) {
    taskAssignment {
      ...TaskAssignmentDetail
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskAssignmentDetail on TaskAssignmentStateData {
  taskAssignmentId
  taskEventName
  assignedTo
  status
  sourceLevel
  productionJobId
  productionJobNumber
  startedAt
  startedBy
  completedAt
  completedBy
  notes {
    content
    addedBy
    addedAt
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const ChangeTaskAssignmentDueDateDocument = new TypedDocumentString(`
    mutation ChangeTaskAssignmentDueDate($input: AssignDueDateInput!) {
  changeTaskAssignmentDueDate(input: $input) {
    taskAssignment {
      ...TaskAssignmentDetail
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskAssignmentDetail on TaskAssignmentStateData {
  taskAssignmentId
  taskEventName
  assignedTo
  status
  sourceLevel
  productionJobId
  productionJobNumber
  startedAt
  startedBy
  completedAt
  completedBy
  notes {
    content
    addedBy
    addedAt
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const AddTaskAssignmentNoteDocument = new TypedDocumentString(`
    mutation AddTaskAssignmentNote($input: AddNoteInput!) {
  addTaskAssignmentNote(input: $input) {
    taskAssignment {
      ...TaskAssignmentDetail
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskAssignmentDetail on TaskAssignmentStateData {
  taskAssignmentId
  taskEventName
  assignedTo
  status
  sourceLevel
  productionJobId
  productionJobNumber
  startedAt
  startedBy
  completedAt
  completedBy
  notes {
    content
    addedBy
    addedAt
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const StartTaskAssignmentTimerDocument = new TypedDocumentString(`
    mutation StartTaskAssignmentTimer($input: StartTimerInput!) {
  startTaskAssignmentTimer(input: $input) {
    taskAssignment {
      ...TaskAssignmentDetail
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskAssignmentDetail on TaskAssignmentStateData {
  taskAssignmentId
  taskEventName
  assignedTo
  status
  sourceLevel
  productionJobId
  productionJobNumber
  startedAt
  startedBy
  completedAt
  completedBy
  notes {
    content
    addedBy
    addedAt
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const StopTaskAssignmentTimerDocument = new TypedDocumentString(`
    mutation StopTaskAssignmentTimer($input: StopTimerInput!) {
  stopTaskAssignmentTimer(input: $input) {
    taskAssignment {
      ...TaskAssignmentDetail
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskAssignmentDetail on TaskAssignmentStateData {
  taskAssignmentId
  taskEventName
  assignedTo
  status
  sourceLevel
  productionJobId
  productionJobNumber
  startedAt
  startedBy
  completedAt
  completedBy
  notes {
    content
    addedBy
    addedAt
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateTaskAssignment: build.mutation<CreateTaskAssignmentMutation, CreateTaskAssignmentMutationVariables>({
      query: (variables) => ({ document: CreateTaskAssignmentDocument, variables })
    }),
    StartTask: build.mutation<StartTaskMutation, StartTaskMutationVariables>({
      query: (variables) => ({ document: StartTaskDocument, variables })
    }),
    CompleteTask: build.mutation<CompleteTaskMutation, CompleteTaskMutationVariables>({
      query: (variables) => ({ document: CompleteTaskDocument, variables })
    }),
    CancelTask: build.mutation<CancelTaskMutation, CancelTaskMutationVariables>({
      query: (variables) => ({ document: CancelTaskDocument, variables })
    }),
    ReassignTask: build.mutation<ReassignTaskMutation, ReassignTaskMutationVariables>({
      query: (variables) => ({ document: ReassignTaskDocument, variables })
    }),
    ChangeTaskAssignmentDueDate: build.mutation<ChangeTaskAssignmentDueDateMutation, ChangeTaskAssignmentDueDateMutationVariables>({
      query: (variables) => ({ document: ChangeTaskAssignmentDueDateDocument, variables })
    }),
    AddTaskAssignmentNote: build.mutation<AddTaskAssignmentNoteMutation, AddTaskAssignmentNoteMutationVariables>({
      query: (variables) => ({ document: AddTaskAssignmentNoteDocument, variables })
    }),
    StartTaskAssignmentTimer: build.mutation<StartTaskAssignmentTimerMutation, StartTaskAssignmentTimerMutationVariables>({
      query: (variables) => ({ document: StartTaskAssignmentTimerDocument, variables })
    }),
    StopTaskAssignmentTimer: build.mutation<StopTaskAssignmentTimerMutation, StopTaskAssignmentTimerMutationVariables>({
      query: (variables) => ({ document: StopTaskAssignmentTimerDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateTaskAssignmentMutation, useStartTaskMutation, useCompleteTaskMutation, useCancelTaskMutation, useReassignTaskMutation, useChangeTaskAssignmentDueDateMutation, useAddTaskAssignmentNoteMutation, useStartTaskAssignmentTimerMutation, useStopTaskAssignmentTimerMutation } = injectedRtkApi;
